import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function AreasWeCover() {
  return;
}